module.exports = __webpack_public_path__ + "static/media/inversiones.3404162a.svg";